import { render } from "./productFilters.vue?vue&type=template&id=0a666174&scoped=true&ts=true"
import script from "./productFilters.vue?vue&type=script&lang=ts"
export * from "./productFilters.vue?vue&type=script&lang=ts"

import "./productFilters.vue?vue&type=style&index=0&id=0a666174&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a666174"]])

export default __exports__